/* eslint-disable no-plusplus */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const Filter = ({
    interval,
    total,
    style,
    handleChange,
}) => {
    const [options, setOptions] = useState([]);

    useEffect(() => {
        const effectUnits = Math.ceil(total / interval);
        const newOptions = Array(effectUnits).fill().map((_, index) => ({
            start: index * interval,
            end: (((index + 1) * interval) - 1),
        }));
        setOptions(newOptions);
    }, []);

    return (
        <select
            className={style}
            onChange={e => handleChange(options[e.target.value])}
        >
            {options.map(({ start, end }, i) => (
                <option
                    key={i}
                    value={i}
                >
                    {`${start} - ${end}`}
                </option>
            ))}
        </select>
    );
};

Filter.propTypes = {
    interval: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    style: PropTypes.string,
    handleChange: PropTypes.func,
};

Filter.defaultProps = {
    style: null,
    handleChange: () => ({}),
};

export default Filter;
